import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../pages/Sidebar";

export default function AppLayout() {
  const location = useLocation();

  return (
    <div className="flex h-screen bg-slate-50">
      <Sidebar path={location.pathname} />
      <main className="flex-1 p-6 overflow-y-auto bg-gradient-to-br from-slate-50 to-slate-100 w-full">
        <div className="w-full h-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
